<template>
  <div class="user-deal-container">
    <h1 class="title">Hello单身部落用户注册协议</h1>

    <dl class="deal-section">
      <dt class="deal-title">1、总则</dt>
      <dd class="deal-item">1.1 Hello单身部落平台的所有权和运营权归广州奇点网络信息有限公司所有。 本协议由广州奇点网络信息有限公司（以下简称“奇点”）与您共同缔结。 Hello单身部落平台包括但不限于Hello单身部落网站（域名为hellobuluo.com）、Hello单身部落旗下的小程序、微信公众号、微博等各类平台的官方账号。</dd>
      <dd class="deal-item">1.2 用户在注册之前，应当仔细阅读本协议，并同意遵守本协议后方可成为注册用户。一旦注册成功，则用户与奇点之间自动形成协议关系，用户应当受本协议的约束。用户在使用特殊的服务或产品时，应当同意接受相关协议后方能使用。</dd>
      <dd class="deal-item">1.3 本协议则可由奇点随时更新，用户应当及时关注并同意本平台不承担通知义务。本平台的通知、公告、声明或其它类似内容是本协议的一部分。新增或变更后的协议和规则一经在平台公布后，立即或在公告明确的特定时间自动生效，并适用于发布后对Hello单身部落平台的一切访问和使用行为。 若您在前述新增或变更公告后继续使用Hello单身部落平台服务的，即表示您已经仔细阅读、充分理解并接受经新增或修订的协议和规则。 若您不同意相关协议、规则内容，应当立即停止使用Hello单身部落平台服务。您可随时查阅最新协议。</dd>
    </dl>

    <dl class="deal-section">
      <dt class="deal-title">2、服务内容</dt>
      <dd class="deal-item">2.1 Hello单身部落提供的产品、内容及权益参见实际情况，且随时更新其产品、内容及权益。用户在使用本产品及服务时，视为已知晓并同意且接受当前的产品、内容、权益及变更。</dd>
      <dd class="deal-item">2.2 本平台仅提供相关的网络服务，除此之外与相关网络服务有关的设备(如个人电脑、手机、及其他与接入互联网或移动网有关的装置)及所需的费用(如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费)均应由用户自行负担。</dd>
      <dd class="deal-item">2.3 本平台的增值服务是以收费的方式提供的，如您使用增值服务，请遵守相关协议。您理解并同意：本平台可能根据实际需求对增值服务的收费标准、方式进行修改和变更。本平台也可能会对部分免费的服务开始收费。前述修改、变更或开始收费前，将在相应页面进行通知或告知。如您不同意上述修改、变更或付费内容，则应停止使用该服务。</dd>
    </dl>

    <dl class="deal-section">
      <dt class="deal-title">3、用户帐号</dt>
      <dd class="deal-item">3.1 经本平台注册系统完成注册程序的用户即成为注册用户，可以获得本平台规定的注册用户所应享有的权限；自愿上传证件资料（如身份证、工作证、营业执照等证件）委托平台做实名审查且通过审查的用户即成为实名用户，可获得实名用户所应享有的权限； 购买会员套餐的用户在套餐生效期间即为VIP会员用户，可获得VIP用户所应享有的权限； 购买其他特殊服务的用户在服务生效期间应享有应有的特殊权限；Hello单身部落平台有权对所有类型用户的权限设计进行变更。</dd>
      <dd class="deal-item">3.2 用户只能按照注册要求使用真实姓名、真实联系方式包括手机号及微信号、真实岗位工作及所在公司等真实情况进行注册。如发现有虚假信息存在，将禁止用户的部分权限使用，具体禁用情况视虚假情况而定。用户有义务保证密码和帐号的安全，用户利用该密码和帐号所进行的一切行为引起的任何损失或损害，由用户自行承担全部责任，本平台不承担任何责任。如用户发现帐号遭到未授权的使用或发生其他任何安全问题，应立即修改帐号密码并妥善保管，如有必要，请通知本平台。因黑客行为或用户的保管疏忽导致帐号非法使用，本平台不承担任何责任。</dd>
    </dl>

    <dl class="deal-section">
      <dt class="deal-title">4、用户使用规则</dt>
      <dd class="deal-item">4.1 遵守中华人民共和国相关法律法规，包括但不限于《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》、《最高人民法院关于审理涉及计算机网络著作权纠纷案件适用法律若干问题的解释(法释[2004]1号)》、《全国人大常委会关于维护互联网安全的决定》、《互联网电子公告服务管理规定》、《互联网新闻信息服务管理规定》、《互联网著作权行政保护办法》和《信息网络传播权保护条例》等有关计算机互联网规定和知识产权的法律和法规、实施办法。</dd>
      <dd class="deal-item">4.2 用户对其自行发表、上传或传送的内容负全部责任，所有用户不得在本平台任何页面发布、转载、传送含有下列内容之一的信息，否则本平台有权自行处理并不通知用户：</dd>
      <dd class="deal-item">(1) 违反宪法确定的基本原则的；</dd>
      <dd class="deal-item">(2) 危害国家安全，泄漏国家机密，颠覆国家政权，破坏国家统一的；</dd>
      <dd class="deal-item">(3) 损害国家荣誉和利益的；</dd>
      <dd class="deal-item">(4) 煽动民族仇恨、民族歧视，破坏民族团结的；</dd>
      <dd class="deal-item">(5) 破坏国家宗教政策，宣扬邪教和封建迷信的；</dd>
      <dd class="deal-item">(6) 散布谣言，扰乱社会秩序，破坏社会稳定的；</dd>
      <dd class="deal-item">(7) 散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</dd>
      <dd class="deal-item">(8) 侮辱或者诽谤他人，侵害他人合法权益的；</dd>
      <dd class="deal-item">(9) 煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；</dd>
      <dd class="deal-item">(10)以非法民间组织名义活动的；</dd>
      <dd class="deal-item">(11)含有法律、行政法规禁止的其他内容的。</dd>
      <dd class="deal-item">(12)其他Hello单身部落明文规定所禁止的，如虚假信息、外链信息、广告信息等内容。</dd>
      <dd class="deal-item">4.3 用户对其在本平台的所有行为负全部责任，所有用户的行为不得违反含有下列内容之一的信息，否则本平台有权自行处理并不通知用户：</dd>
      <dd class="deal-item">(1)不得为任何非法目的而使用网络服务系统；</dd>
      <dd class="deal-item">(2)遵守所有与网络服务有关的网络协议、规定和程序；</dd>
      <dd class="deal-item">(3)不得利用本平台进行任何可能对互联网的正常运转造成不利影响的行为；</dd>
      <dd class="deal-item">(4)不得利用本平台进行任何不利于本平台的行为。</dd>
      <dd class="deal-item">4.4 当第三方认为用户发表或者上传于本平台的信息或某些行为侵犯其权利，并根据《信息网络传播权保护条例》或者相关法律规定向本平台发送权利通知书时，用户同意本平台可以自行判断决定删除涉嫌侵权信息，除非用户提交书面证据材料排除侵权的可能性，本平台将不会自动恢复上述删除的信息；</dd>
      <dd class="deal-item">4.5 如用户在使用网络服务时违反上述任何规定，本平台有权要求用户改正或直接采取一切必要的措施(包括但不限于删除用户张贴的内容、暂停或终止用户使用网络服务的权利)以减轻用户不当行为而造成的影响。</dd>
      <dd class="deal-item">4.6 您的账号和密码归本人所有，不得以任何方式出借、买卖、转让、赠与或继承，除非有法律明确规定或司法裁定，并经奇点同意。</dd>
      <dd class="deal-item">4.7 如您连续12个月未登陆过Hello单身部落，且您账户下不存在未到期的有效业务，您的账号和内容可能被注销。</dd>
    </dl>

    <dl class="deal-section">
      <dt class="deal-title">5、隐私保护</dt>
      <dd class="deal-item">5.1 用户的非公开资料（隐私资料）包括真实姓名、手机号等在本网站上不对公众用户展开的部分隐私内容。</dd>
      <dd class="deal-item">5.2 本平台不对外公开或向第三方提供单个用户的非公开部分的注册资料及用户在使用网络服务时存储在本平台的非公开内容，但下列情况除外：</dd>
      <dd class="deal-item">(1) 事先获得用户的明确授权；</dd>
      <dd class="deal-item">(2) 根据有关的法律法规要求；</dd>
      <dd class="deal-item">(2) 根据有关的法律法规要求；</dd>
      <dd class="deal-item">(3) 按照相关政府主管部门的要求；</dd>
      <dd class="deal-item">(4) 为维护社会公众的利益。</dd>
      <dd class="deal-item">(5) 有社交需求的用户所需要提供的信息，如微信号等；</dd>
      <dd class="deal-item">5.2 本平台可能会与第三方合作向用户提供相关的网络服务，在此情况下，如该第三方同意承担与本平台同等的保护用户隐私的责任， 则本平台有权将用户的注册资料等提供给该第三方。</dd>
      <dd class="deal-item">5.3 在不透露单个用户隐私资料的前提下，本平台有权对整个或单个用户信息进行本网站相关商业上的使用。且有权对整体用户资料数据库进行分析并对用户数据库进行本网站相关商业上的使用。</dd>
    </dl>

    <dl class="deal-section">
      <dt class="deal-title">6、版权声明</dt>
      <dd class="deal-item">6.1 本平台的文字、图片、音频、视频等版权均归广州奇点网络信息有限公司享有，未经本平台许可，不得任意转载。</dd>
      <dd class="deal-item">6.2 本平台特有的标识、版面设计、编排方式等版权均属广州奇点网络信息有限公司享有，未经本平台许可，不得任意复制或转载。</dd>
      <dd class="deal-item">6.3 使用本平台的任何内容均应注明“来源于Hello单身部落”并通知本平台及作者，并独立承担一切法律责任。</dd>
      <dd class="deal-item">6.4 本平台享有所有信息用于其它用途的优先权，包括但不限于网站、电子杂志、平面出版等。您同意奇点持有您在Hello单身部落平台所发布的内容在全球范围内免费的、 不可撤销的、永久的、可再许可或转让的独家使用权许可。奇点依据该许可将有权以展示、推广及其他不为我国法律所禁止的方式使用。</dd>
      <dd class="deal-item">6.5 本平台所有内容仅代表作者自己的立场和观点，与本平台无关，由作者本人承担一切法律责任。</dd>
      <dd class="deal-item">6.6 恶意盗取和转载本平台内容的，本平台保留将其诉诸法律的权利。</dd>
    </dl>

    <dl class="deal-section">
      <dt class="deal-title">7、责任声明</dt>
      <dd class="deal-item">7.1 用户明确同意其使用本平台网络服务所存在的风险及一切后果将完全由用户本人承担，本平台对此不承担任何责任。</dd>
      <dd class="deal-item">7.2 本平台的信息资料皆来源于用户本身，平台只是做信息的展示和功能的实现，用户需对自己提供的资料真实性负全部责任，如有虚假信息欺诈行为，本平台有权追责。</dd>
      <dd class="deal-item">7.3 用户上传证件资料（如身份证、营业执照、工作证、劳动合同等）委托本平台做实名审核，审核通过后则成为平台的实名用户。本平台只做资料核对和形式上的审查，真实度有限，仅可作为实名参考，并不承担任何担保。</dd>
      <dd class="deal-item">7.4 请大家在使用本平台交友过程中保护好自己， 对自身的人身和财产安全负全部责任， 做好安全防范措施，避免财产往来和过密接触。因此而产生的的纠纷违法等行为，平台本身不负责任何法律责任。</dd>
      <dd class="deal-item">7.5 如遇到虚假信息、欺骗行为、不良目的或人品素质等有问题的用户，欢迎向本平台投诉并举证。平台将视具体情况做出相应的处理（如限制该用户权限、账号封禁、全平台公告等方式），以保障他人的权益和安全。</dd>
      <dd class="deal-item">7.6 本平台无法保证网络服务一定能满足用户的要求，也不保证网络服务的及时性、安全性、准确性。</dd>
      <dd class="deal-item">7.7 对于因不可抗力或本平台不能控制的原因造成的网络服务中断或其它缺陷，本平台不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。</dd>
      <dd class="deal-item">7.8 对于本平台向用户提供的下列产品或者服务的质量缺陷本身及其引发的任何损失，本平台无需承担任何责任：</dd>
      <dd class="deal-item">(1)本平台向用户免费提供的各项网络服务；</dd>
      <dd class="deal-item">(2)本平台向用户赠送的任何产品或者服务。</dd>
      <dd class="deal-item">7.9 本平台有权于任何时间暂时或永久修改或终止本服务(或其任何部分)，而无论其通知与否，本平台对用户和任何第三人均无需承担任何责任。</dd>
      <dd class="deal-item">7.10 您承认并同意，奇点可立即关闭或删除您的账号及您账号中所有相关违反平台信息管理的内容及文件，及/或禁止继续使用前述文件或本服务。此外，您同意奇点为此对您或第三方不承担任何责任。</dd>
      <dd class="deal-item">7.11 您明确同意将您所发布的文字、资讯、资料、音乐、照片、图形、视讯、信息或其它资料上传到互联网， 所有可能被其他组织或个人复制、转载、或做其它用途的风险及后果将由您自行承担。奇点不承担任何责任。</dd>
      <dd class="deal-item">7.12 微博、微信、等官方账号对您的相关文字、资讯、资料、音乐、照片、图形、视讯、信息或其它个人资料进行推广发布的，不属于对您相关权益的侵权行为。奇点不承担任何责任。</dd>
      <dd class="deal-item">7.13 您通过Hello单身部落平台发布或传送的任何信息、通讯资料等，若未储存或被删除，奇点不承担任何责任。</dd>
    </dl>
    <dl class="deal-section">
      <dt class="deal-title">8、附则</dt>
      <dd class="deal-item">8.1 本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。</dd>
      <dd class="deal-item">8.2 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</dd>
      <dd class="deal-item">8.3 本协议解释权及修订权归广州奇点网络信息有限公司所有。</dd>
    </dl>
  </div>
</template>

<script>
export default {
  name: 'userDeal'
}
</script>

<style lang="scss">
.user-deal-container {
  padding: 30px 40px 80px;
  .title {
    font-size: 32px;
    line-height: 44px;
    font-weight: bold;
    text-align: center;
  }
  .deal-section {
    margin-top: 30px;
    font-size: 22px;
    line-height: 44px;
    text-align: left;
  }
  .deal-item {
    color: #696969;
  }
}
</style>
